import React from "react";
import { cn } from "../utils/cn";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "document" | "outlined" | "elevated";
  docLabel?: React.ReactNode;
  docNumber?: string;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = "default", docLabel, docNumber, children, ...props }, ref) => {
    const variants = {
      default: "bg-thema-surface/40 border border-thema-border/60",
      document:
        "bg-thema-surface border border-[rgba(255,255,255,0.06)] relative",
      outlined: "bg-transparent border border-thema-border-faint",
      elevated:
        "bg-thema-surface-alt border border-thema-border/50 shadow-neon",
    };

    return (
      <div
        ref={ref}
        className={cn(
          "rounded-[6px] p-8",
          variants[variant],
          className
        )}
        {...props}
      >
        {variant === "document" && (
          <>
            {docLabel && (
              <div className="mb-3 font-mono text-[10px] uppercase tracking-[0.12em] text-thema-micro opacity-65">
                {docLabel}
              </div>
            )}
            {docNumber && (
              <div className="absolute top-4 right-4 font-mono text-[9px] uppercase tracking-[0.2em] text-thema-faint opacity-50">
                {docNumber}
              </div>
            )}
          </>
        )}
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";

